function addDays(date, days) {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

export const actions = {
};

export const mutations = {
  update(state, keyValue) {
    // eslint-disable-next-line no-param-reassign
    state[keyValue.key] = keyValue.value;

    if (keyValue.key === 'arrival_date' || keyValue.key === 'departure_date') {
      const dateStart = new Date(state.arrival_date);
      const dateEnd = new Date(state.departure_date);
      state.number_of_days = (dateEnd.getTime() - dateStart.getTime()) / 1000 / 60 / 60 / 24 + 1;
    }
  },
};

export const state = () => ({
  domain: {
    country: '',
    country_code: '',
    language: '',
    name: '',
  },
  page_type: 'home',
  airport: {
    id: '',
    name: '',
    slug: '',
    commonName: '',
    internationalAirportName: '',
  },
  merchant: {
    name: '',
    id: '',
    slug: '',
  },
  arrival_date: addDays(new Date(), 7).toISOString().split('T')[0],
  departure_date: addDays(new Date(), 13).toISOString().split('T')[0],
  number_of_days: '7',
  review_score: '',
  review_amount: '',
  outbound: '',
  error_message: '',
  error_url: '',
  error_line: '',
  currency: '',
  item_category: '',
  item_list_name: '',
  category: '',
  event_interaction: '',
  event_status: '',
  arrival_time: '12:00',
  departure_time: '12:00',
  pickerInteracted: '',
});
